import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService  } from "./AuthService";

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService) { }

    canActivate(): Promise<boolean> {
        return new Promise((resolve, reject) => { 
            this.authService.getUser().then(user => {
                if (user == null || user.expired) {                  
                    this.authService.startAuthentication().then((user) => {
                        if (user == null) {
                            resolve(false);
                        }
                        else {
                            resolve(true);
                        }
                    })   
                } else {                    
                    resolve(true);
                }
            });
        });        
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/auth/AuthGuardService.ts